import React from "react";
import styled from "styled-components";
import ContentEditable from "react-contenteditable";
import { ASSETS } from "../../../../../utils/config";
import { transformEditorTextNoStyles } from "../../../../../utils/helpers";
import WheelComponent from "../../../../WheelComponent";
import { v4 as uuidv4 } from "uuid";

const ListItemContainer = styled.div`
  display: flex;
  align-items: center;
`;

const WheelWrapper = styled.div`
  width: 70px;
  height: 70px;
`;

const WheelName = styled.div`
  font-size: 14px;
  color: #333;
`;

const WheelListItem = ({ data = {} }) => {
  const wheelSegments = Array.isArray(data?.wheel_segments)
    ? data.wheel_segments
    : [];

  const wheelUpdatedData = [...wheelSegments]?.map((obj) => ({
    ...obj,
  }));

  const wheelUpdatedDataSorted = wheelUpdatedData.sort(
    (a, b) => a.position - b.position
  );

  const getWheelBackground = (wallpaperSettings = {}) => {
    const { bg_wallpaper, current_bg, segment_bg_color } = wallpaperSettings;
    if (current_bg === 2 || current_bg === 3) {
      return bg_wallpaper;
    }
    return segment_bg_color;
  };

  return (
    <ListItemContainer>
      <WheelWrapper>
        <WheelComponent
          userData={{
            id: uuidv4(),
            url: data?.wheel_image || ASSETS.userPlaceholder,
          }}
          maxSelectedArcs={0}
          arcThickness={10}
          chartData={wheelUpdatedDataSorted || []}
          margin={25}
          setChartData={() => {}}
          containerDivStyle={{
            width: "100%",
            height: "100%",
          }}
        />
      </WheelWrapper>
      <WheelName>
        <ContentEditable
          html={transformEditorTextNoStyles(data?.wheel_name)}
          disabled
        />
      </WheelName>
    </ListItemContainer>
  );
};

export default WheelListItem;